import { ConsultationTreatmentTypes } from '@enums/consultation-treatment-types';
import { Gender } from '@enums/gender';
import { Pharmacy } from '@enums/pharmacies';
import { TreatmentGenderSettings } from '@models/treatment-types/treatment-gender-settings.model';
import { TreatmentType } from '@models/treatment-types/treatment-type.model';

/**
 * Defines the Peptide Renewal treatment type.
 */
export const PeptideRenewalTreatmentType = new TreatmentType({
  id: '25',
  name: ConsultationTreatmentTypes.PeptideRenewal,
  designatedPharmacyId: Pharmacy.CASA_PHARMA,
  genderSettings: new TreatmentGenderSettings({
    excludedForUpsells: {
      '/consultation/testosterone-therapy': Gender.Female,
      '/consultation/sexual-performance': Gender.Female,
    },
  }),
  requireHeightAndWeight: true,
});
